function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["event"],
  _excluded2 = ["event"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { isIdentityAvailable, getUserId, getUserType } from "../utils/identity";
import Queue from "../Queue";

// Create a localstorage buffer for the Meta Pixel events
var queue = new Queue('ab_events-buffer-for-metapixel');

/**
 * Once the current user is identified, this method dispatches events from the localstorage.
 */
var sendEventsFromLocalstorage = function sendEventsFromLocalstorage() {
  if (queue.size() > 0) {
    // Dispatch one event at a time (from localstorage)
    for (var index = 0; index < queue.size(); index++) {
      var _queue$dequeue = queue.dequeue(),
        eventName = _queue$dequeue.event,
        data = _objectWithoutProperties(_queue$dequeue, _excluded);
      // Events in the localstorage were missing the User ID and Role,
      // now that they're available we will assign the values
      var eventData = _objectSpread(_objectSpread({}, data), {}, {
        event: eventName,
        user_id: getUserId(),
        user_type: getUserType()
      });
      // Meta Pixel is loaded by Google Tag Manager as a global object
      fbq('trackCustom', eventName, eventData); // NOTE: In the next release, we will move from client-side tracking
      // to server-side tracking to avoid ab-blockers (utilizing UI Services API)
    }
  }
};

/**
 * Dispatches events to the Meta Pixel or temporary stored them in the localstorage until user is
 * identified. Once the user is identified it will first dispatch events from the localstorage
 * before dispatching the latest event.
 *
 * Events have timestamp at the moment they were created so the timeline will be respected
 * regardless of events being immediatelly dispatched to the Meta Pixel or temporary stored
 * in the localstorage.
 * @param event
 */
export var sendEventToMetaPixel = function sendEventToMetaPixel(event) {
  try {
    // Make sure that an error dispatching event does not bring the application down
    if (isIdentityAvailable()) {
      // Second, check if there are any events in the localstorage and send them first
      sendEventsFromLocalstorage();
      // Finally, send the latest created event
      if (event) {
        var eventName = event.event,
          data = _objectWithoutProperties(event, _excluded2);
        // Identity is available, set the 'user_id' and 'user_type' in the event data
        var eventData = _objectSpread(_objectSpread({}, data), {}, {
          event: eventName,
          user_id: getUserId(),
          user_type: getUserType()
        });
        // Meta Pixel is loaded by Google Tag Manager as a global object
        fbq('trackCustom', eventName, eventData);
      }
    } else {
      // Temporary store event in the localstorage (until the identity of the user is set)
      if (event) {
        queue.enqueue(event);
      }
    }
  } catch (e) {
    // Something went wrong while dispatching or storing event, create a warning with error
    console.warn('Meta Pixel Plugin: Failed to dispatch event', e);
  }
};